<template>
  <div class="page_settlementTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="系统字段" size="small">
              <el-input v-model="listQuery.key" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <!-- <el-form-item label="原始字段" size="small">
              <el-input v-model="listQuery.value" size="small" clearable style="width:180px"></el-input>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI小杰</el-breadcrumb-item>
          <el-breadcrumb-item>字典库</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="结算单任务设置" name="0"></el-tab-pane>
          <el-tab-pane label="入职任务设置" name="1"></el-tab-pane>
          <el-tab-pane label="银行任务设置" name="2"></el-tab-pane>
          <el-tab-pane label="任务缺省设置" name="3"></el-tab-pane>
          <el-tab-pane label="字典库" name="4"></el-tab-pane>
          <el-tab-pane label="入职参保规则" name="5"></el-tab-pane>
          <el-tab-pane label="入职签约规则" name="6"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2">
          <el-tab-pane label="结算单字典" name="0"></el-tab-pane>
          <el-tab-pane label="入职登记字典" name="1"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex" v-if="activeName2=='0'">
          <!-- <el-button type="primary" size="small">导出</el-button> -->
          <el-button type="success" size="small" @click="addNewModel">新增模板</el-button>
        </div>
        <div class="ftabBtn flex" v-if="activeName2=='1'">
          <!-- <el-button type="primary" size="small">导出</el-button> -->
          <el-button type="danger" size="small" @click="delHandle">删除系统字段</el-button>
          <el-button type="success" size="small" @click="addNewField">添加系统字段</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100 > 340 ? tableHeight - 100 : 340" v-loading="loading" style="width:100%">
          <template v-if="activeName2=='0'">
            <el-table-column prop="key" label="模板名称" key="1" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="value" label="是否缺省" key="2" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="msg2" label="状态" key="3" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" min-width="100" key="4" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="toDtl(row)">详情</el-button>
                  <el-button type="text" size="small" @click="editModel(row)">编辑</el-button>
                  <el-button type="text" size="small" @click="enableHandle(row)">{{ row.msg2 == '启用' ? '禁用' : '启用' }}</el-button>
                  <el-button type="text" size="small" @click="delModel(row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="activeName2=='1'">
            <el-table-column key="mul" type="selection" width="55" align="center"></el-table-column>
            <el-table-column prop="key" label="系统字段" key="1" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="defaultValue" label="缺省值" key="2" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="msg2" label="规则" key="3" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="fieldName" label="原始字段" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
            <el-table-column prop="value" label="匹配原始字段/计算公式" key="4" min-width="300" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <span v-if="row.msg2 == '匹配字段'">{{ row.value }}</span>
                <span v-if="row.msg2 == '计算公式'">{{ getVal(row.value) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100" key="5" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="editHandel(row)">编辑</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="listQuery.PageModel.Rows" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增/编辑 -->
    <el-dialog :title="type=='add' ? '添加系统字段' : '编辑'" :visible.sync="editVisible" width="600px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="dictForm" :model="dictForm" class="" label-width="100px" size="small" v-if="editVisible">
        <el-form-item label="系统字段:">
          <el-input v-model="dictForm.msg" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="缺省值:">
          <el-input v-model="dictForm.defaultValue" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="规则:">
          <el-select v-model="dictForm.msg2" size="small" filterable clearable placeholder="" style="width: 180px;" @change="chengeType">
            <el-option value="匹配字段"></el-option>
            <el-option value="计算公式"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="匹配原始字段:" v-if="dictForm.msg2 == '匹配字段'">
          <div class="flex" v-for="(item, index) in KeyList" :key="index" style="margin-bottom: 10px;">
            <el-input v-model="KeyList[index]" size="small" clearable style="width:180px"></el-input>
            <div class="blueName cp" style="margin-left: 20px;" @click="delItem(index)">删除</div>
          </div>
          <div class="blueName cp" style="margin-top: 20px;" @click="addItem()">+添加</div>
        </el-form-item>
        <el-form-item label="=" v-if="dictForm.msg2 == '计算公式'">
          <div class="flex">
            <el-select v-model="ruleForm.formula.values[0].name" size="small" placeholder="" style="width: 180px;">
              <el-option v-for="(r, i) in allList" :key="i" :value="r.key"></el-option>
            </el-select>
            <div class="flex aic cp" style="margin-left:10px" @click="addRule" v-if="ruleForm.formula.values.length == 1">
              <i class="el-icon-circle-plus icon01"></i>
              <el-button type="text" style="margin-left:5px">添加</el-button>
            </div>
          </div>
          <div v-for="(item, index) in ruleForm.formula.values" :key="index" class="ruleItem flex" v-if="index != 0">
            <el-select v-model="item.operation" size="small" placeholder="" style="width: 60px;">
              <el-option value="无"></el-option>
              <el-option value="+"></el-option>
              <el-option value="-"></el-option>
              <el-option label="×" value="*"></el-option>
              <el-option label="÷" value="/"></el-option>
            </el-select>
            <el-select v-model="item.name" size="small" placeholder="" style="width: 140px;margin-left: 10px;">
              <el-option value="固定值"></el-option>
              <el-option v-for="(r, i) in allList" :key="i" :value="r.key"></el-option>
            </el-select>
            <el-input v-model="item.value" v-if="item.name == '固定值'" size="small" clearable style="width:100px;margin-left: 10px;"></el-input>
            <i class="el-icon-delete icon02 cp" @click="delRule(index)"></i>
            <div class="flex aic cp" style="margin-left:10px" @click="addRule" v-if="ruleForm.formula.values.length - 1 == index">
              <i class="el-icon-circle-plus icon01"></i>
              <el-button type="text" style="margin-left:5px">添加</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmEdit" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增/编辑 -->
    <el-dialog :title="type=='add' ? '新增模板' : '编辑'" :visible.sync="addModelVisible" width="500px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="modelForm" :model="modelForm" class="" label-width="100px" size="small">
        <el-form-item label="模板名称:">
          <el-input v-model="modelForm.msg" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="是否缺省:">
          <el-radio-group v-model="modelForm.msg1">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModelVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddModel" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          BusiId: '字典库模板',
          key: '',
        },
        isbtnLoading: false,
        KeyList: [],
        dictForm: {
          id: '',
          busiId: 30, //BusiId=20 入职登记字段匹配 BusiId=30 结算单字段匹配 BusiId=40 银行流水字段匹配
          msg: '',
          msg1: '',
          msg2: '',
          defaultValue: null
        },
        modelForm: { //新增模板
          busiType: 'RPA机器人',
          busiId: '50',
          msg: '', //模板名称
          msg1: '', //是否缺省  是/否
          msg2: '启用', //状态  启用/禁用
          templateId: ''
        },
        type: '',
        addModelVisible: false,
        editVisible: false,
        activeName: '4',
        activeName2: '0',
        totalCount: 0,
        tableData: [],
        allList: [], //所有字段
        roletype: localStorage.loginRoletype,
        loading: false,
        multipleSelection: [],
        permissionLists: [],
        rules: {},
        ruleForm: {},
        needLoading: false,
      }
    },
    created() {
      this.getList();
      // this.GetAllList();
      // this.getButtonPower();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          this.getList()
          this.needLoading = false;
        } else {}
      })
    },
    methods: {
      checkPermission,
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      //分页
      handleCurrentChange(val) {
        this.listQuery.PageModel.Page = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.PageModel.Page = 1
        this.listQuery.PageModel.Rows = Number(val)
        this.getList()
      },
      getList() {
        this.GetFieldMatchingList();
      },
      GetFieldMatchingList() {
        this.loading = true;
        xz.RPAFun(this.listQuery, 'GetFieldMatchingList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      GetAllList() {
        let d = {
          PageModel: {
            Rows: 1000,
            Page: 1,
            OrderInput: []
          },
          busiType: 'RPA机器人',
          BusiId: '结算单字段匹配',
          key: '',
          value: ''
        }
        xz.RPAFun(d, 'GetFieldMatchingList').then(res => {
          if (res.status == 'ok') {
            this.allList = res.data.data;
          }
        })
      },
      changeTab() {
        if (this.activeName == '0') {
          this.$router.push({
            path: '/settlementTask'
          })
        } else if (this.activeName == '3') {
          this.$router.push({
            path: '/taskSet'
          })
        } else if (this.activeName == '5' || this.activeName == '6') {
          this.$router.push({
            path: '/ruleSet',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            BusiId: '字典库模板',
            key: '',
          }
          this.dictForm.busiId = 30;
          this.getList()
        } else if (this.activeName2 == '1') {
          this.dictForm.busiId = 20;
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            busiType: 'RPA机器人',
            BusiId: '入职登记字段匹配',
            key: '',
            value: ''
          }
          this.getList()
        }
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //编辑
      editHandel(row) {
        this.dictForm = {
          id: row.id,
          busiId: this.dictForm.busiId,
          msg: row.key,
          msg1: row.value,
          msg2: row.msg2,
          sort: '',
          defaultValue: row.defaultValue
        }
        if (row.msg2 != '计算公式') {
          let d = row.value.replace(/，/g, ',');
          this.KeyList = d.split(',');
        } else {
          this.ruleForm = JSON.parse(row.value);
          console.log(this.ruleForm)
        }
        this.isbtnLoading = false;
        this.type = 'edit';
        this.editVisible = true;
      },
      chengeType(val) {
        if (val == '计算公式') {
          this.ruleForm = {
            formula: {
              operator: '=',
              values: [{
                name: ''
              }],
            },
            rule: '计算公式',
            systemField: this.dictForm.msg
          }
        }
      },
      addNewField() {
        this.isbtnLoading = false;
        this.KeyList = [''];
        this.dictForm = {
          id: '',
          busiId: this.dictForm.busiId,
          defaultValue: null,
          msg: '',
          msg1: '',
          msg2: '',
          sort: ''
        }
        this.type = 'add';
        this.editVisible = true;
      },
      //新增匹配字段
      addItem() {
        this.KeyList.push('')
      },
      delItem(i) {
        this.KeyList.splice(i, 1)
      },
      //添加计算公式
      addRule() {
        let d = {
          name: '',
          operation: '',
          value: null,
        }
        this.ruleForm.formula.values.push(d);
      },
      delRule(i) {
        this.ruleForm.formula.values.splice(i, 1)
      },
      confirmEdit() {
        if (this.dictForm.msg2 == '匹配字段') {
          let canEdit = true;
          this.KeyList.forEach((e, i) => {
            if (!e) {
              canEdit = false;
            }
            if (i == this.KeyList.length - 1) {
              if (canEdit) {
                this.dictForm.msg1 = this.KeyList.toString();
                this.confirmEdit2();
              } else {
                this.$message.warning('匹配原始字段不能为空！')
              }
            }
          });
        } else {
          this.dictForm.msg1 = JSON.stringify(this.ruleForm);
          this.confirmEdit2()
        }
      },
      confirmEdit2() {
        this.isbtnLoading = true;
        xz.RPAFun(this.dictForm, 'CreateOrEditDicData').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功');
            this.editVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      delHandle() {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.id)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                id: arr
              }
              xz.RPAdel(d, 'DeleteToget').then(res => {
                if (res.status == 'ok') {
                  this.getList();
                  this.loading = false;
                  this.$message.success('删除成功');
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          });
        } else {
          this.$message.warning('请至少选择一个任务')
        }
      },
      getVal(val) {
        let v = JSON.parse(val);
        // v.formula.values[0].name + 
        let str = ''
        v.formula.values.forEach((e, i) => {
          if (e.operation != undefined && e.operation) {
            str = str + e.operation
          }
          if (e.name != '固定值') {
            str = str + e.name
          } else {
            str = str + e.value
          }
        });
        return str
      },
      addNewModel() {
        this.modelForm = {
          busiType: 'RPA机器人',
          busiId: '50',
          msg: '', //模板名称
          msg1: '否', //是否缺省  是/否
          msg2: '启用', //状态  启用/禁用
          templateId: ''
        }
        this.addModelVisible = true;
      },
      editModel(row) {
        this.modelForm = {
          id:row.id,
          busiType: 'RPA机器人',
          busiId: '50',
          msg: row.key, //模板名称
          msg1: row.value, //是否缺省  是/否
          msg2: row.msg2, //状态  启用/禁用
          templateId: row.templateId
        }
        this.addModelVisible = true;
      },
      toDtl(row) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/dictDtl",
          query: {
            id: row.id
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      confirmAddModel() {
        this.isbtnLoading = true;
        xz.RPAFun(this.modelForm, 'CreateOrEditDicData').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功');
            this.addModelVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      enableHandle(row) {
        let d = {
          id: [row.id],
          status: row.msg2 == '启用' ? '禁用' : '启用'
        }
        xz.RPAFun(d, 'EnableTogeBusi').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('操作成功');
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      delModel(row) {
        let d = {
          id: [row.id]
        }
        xz.RPAdel(d, 'DeleteToget').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('删除成功');
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ruleItem {
    margin-top: 10px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    // color: #19bd92;
    font-size: 20px;
    cursor: pointer;
    margin-left: 5px;
    line-height: 32px;
  }
</style>
<style>
  .page_settlementTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementTask .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>